export function validateCPF(cpf?: string): boolean {
  if (!cpf) {
    return false;
  }

  const c = cpf.replace(/[^\d]/g, "");

  if (c.length !== 11 || /^(.)\1+$/.test(c)) {
    return false;
  }

  const calcDigit = (slice: string, weights: number[]): number => {
    const sum = slice
      .split("")
      .reduce((acc, digit, i) => acc + Number(digit) * weights[i], 0);
    return ((sum * 10) % 11) % 10;
  };

  const firstDigit = calcDigit(c.slice(0, 9), [10, 9, 8, 7, 6, 5, 4, 3, 2]);
  const secondDigit = calcDigit(
    c.slice(0, 10),
    [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]
  );

  return firstDigit === Number(c[9]) && secondDigit === Number(c[10]);
}

export function formatterCPF(cpf?: string): string {
  if (!cpf) return "";

  const numeros = cpf.replace(/\D/g, "");

  if (numeros.length !== 11) {
    throw new Error("CPF inválido. Deve conter 11 dígitos.");
  }

  return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

// Máscara de privacidade pra listagens (esconde os 6 dígitos do meio, ex:
// "321.***.***-05") — diferente de formatterCPF, que só formata o número
// completo sem esconder nada (usado nos formulários de edição, onde o
// usuário precisa ver/conferir o CPF real).
export function maskCpfParcial(cpf?: string): string {
  if (!cpf) return "";
  const numeros = cpf.replace(/\D/g, "");
  if (numeros.length !== 11) return cpf;
  return `${numeros.slice(0, 3)}.***.***-${numeros.slice(9, 11)}`;
}

// Máscara progressiva (aplica pontuação conforme o usuário digita), mesmo
// padrão de maskCnpj em cnpj.util.ts — usada nos campos de formulário.
export const maskCpf = (value: string): string => {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  return digits
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
};
